import React from 'react'
import {
    Box,
    Stack
} from '@mui/material'
import * as Images from '../../components/UIComponents/Images'
import * as Buttons from '../../components/UIComponents/Button'
import * as Texts from '../../components/UIComponents/Text'

const { innerWidth } = window

const FAQBotOnboarding = ({
    headerText,
    descriptionText,
    call2ActionText,
    onClick
}) => {
    return (

        <Stack
            direction="column"
            justifyContent={"space-between"}
            spacing={{
                xs: 2,
                sm: 4,
                md: 8
            }}
            sx={{
                pt: {
                    xs: 4,
                    md:6
                },
                px: {
                    xs: 2,
                    md: 6
                }
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    height: .4,
                    maxHeight: {
                        sx: 160
                    }
                }}
            >
                <Images.ChatbotOnboarding />
            </Box>
            <Stack
                direction="column"
                justifyContent={"center"}
                spacing={{
                    xs: 4
                }}
                sx={{
                    textAlign: 'center'
                }}
            >
                <Texts.H4>{headerText}</Texts.H4>
                <Texts.Text>{descriptionText}</Texts.Text>
            </Stack>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center'
                }}
            >
                <Buttons.Button
                    onClick={onClick}
                >
                    <Texts.H4 sx={{ color: "primary.contrastText" }}>{call2ActionText}</Texts.H4>
                </Buttons.Button>
            </Box>
            {/*<Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center'
                }}
            >
                <Texts.Paragraph>What is FAQoid?</Texts.Paragraph>
            </Box>*/}
        </Stack>
    )

}
export default FAQBotOnboarding